module.exports = __webpack_public_path__ + "img/fcm-logotipo.fb4fa32d.svg";